/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

// 工资条后台服务器地址
// export const baseUrl = 'https://gzt.chengyunhr.com'; // cs
export const baseUrl = 'http://www.chengyunhr.cn:8011'; //正式
//export const baseUrl = 'http://8.131.248.33:8163'; //测试
//export const baseUrl = 'http://bobo.vaiwan.com'; //测试
// export const baseUrl = 'http://gzt.renligongshe.com/server'; //本公司用


export default {
  baseUrl
}



// WEBPACK FOOTER //
// ./src/utils/global.js